export default __webpack_public_path__ + "assets/images/nuvama_logo.png";